import { render, staticRenderFns } from "./MergeField.vue?vue&type=template&id=6a047630&scoped=true&"
import script from "./MergeField.vue?vue&type=script&lang=ts&"
export * from "./MergeField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a047630",
  null
  
)

export default component.exports